import { COMUNI_TABS_ITEM } from '@/features/comuni/comuni-helper';
import RouteConstants from '@/features/router/RouteConstants';
import { IconButton } from '@/lib';
import { FC } from 'react';
import { LuQrCode } from 'react-icons/lu';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

type CollectCitizensCardProps = {
  className?: string;
};

export const CollectCitizensCard: FC<CollectCitizensCardProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <section className={twMerge('rounded-xl bg-secondary-background p-8 shadow-sm', className)}>
      <div className='flex flex-col items-center gap-6'>
        <div className='grid gap-5'>
          <h3 className='text-4xl font-semibold text-quaternary-900'>
            <Trans i18nKey='home:collectCitizensTitle'>
              <span className='text-brand-600'>Collect</span> citizens' contacts
            </Trans>
          </h3>
          <h4 className='text-base font-medium text-primary-900'>
            <Trans i18nKey='home:collectCitizensSubtitle'>
              <strong>A QR code at the front desk, a link on your website.</strong> Citizens sign up on their own and choose where to get notices: WhatsApp, SMS
              or email. You only focus on what to say.
            </Trans>
          </h4>
        </div>
        <Link to={`${RouteConstants.comuni}?tab=${COMUNI_TABS_ITEM.CITIZEN_FORMS}`}>
          <IconButton text={t('home:getStarted')} size='xl' leadingIcon={<LuQrCode className='size-5' />} />
        </Link>
      </div>
    </section>
  );
};
